import { apiCall } from './api';
import {
  TutorEarningResponseSchema,
  PayoutRecordResponseSchema,
} from './schemas/earning';
import type {
  TutorEarningResponse,
  PayoutRecordResponse,
} from './schemas/earning';

export async function getMyEarnings(
  accessToken: string,
): Promise<TutorEarningResponse[]> {
  const res = await apiCall<unknown>('/earnings', { accessToken });
  return TutorEarningResponseSchema.array().parse(res.data);
}

export async function requestPayout(
  accessToken: string,
): Promise<PayoutRecordResponse> {
  const res = await apiCall<unknown>('/earnings/payout', {
    accessToken,
    method: 'POST',
    body: {},
  });
  return PayoutRecordResponseSchema.parse(res.data);
}

export async function getMyPayouts(
  accessToken: string,
): Promise<PayoutRecordResponse[]> {
  const res = await apiCall<unknown>('/earnings/payouts', { accessToken });
  return PayoutRecordResponseSchema.array().parse(res.data);
}
